<script>
import isEmpty from 'lodash/isEmpty';
import each from 'lodash/each';
import { useEnvStore } from '@dutypay/store-modules'
import {mapState} from 'pinia';

export default {
  name: "DpImg",
  props: {
    hsId: {type: String, required: true},
    alt: {type: String},
    srcset: {type: Array},
    sizes: {type: String},
    defaultSize: {type: String, default: ''},
    style: {type: String},
    media: {type: String},
    format: {type: String}
  },
  computed: {
    ...mapState(useEnvStore, ['apiUrls']),
    isEmpty() {
      return isEmpty;
    },
    assetsApiEndpoint() {
      return `${this.apiUrls.dutypay}/api/v0/assets`;
    }
  },
  methods: {
    generateSrcset(hsId, format) {
      if (isEmpty(this.srcset)) {
        return `${this.assetsApiEndpoint}/${hsId}/${format}/${this.defaultSize}`;
      }
      let string = '';
      each(this.srcset, (set) => {
        string += `${this.assetsApiEndpoint}/${hsId}/${format}/${set.resourceSize} ${set.renderSize}, `;
      });
      return string;
    }
  }
}
</script>

<template>
  <picture v-if="isEmpty(media)">
    <slot></slot>
    <source :srcset="generateSrcset(hsId, 'webp')"
            :sizes="sizes"
            type="image/webp"/>
    <img :src="`${assetsApiEndpoint}/${hsId}/jpeg/${defaultSize}`"
         :srcset="generateSrcset(hsId, 'jpeg')"
         :style="style"
         :alt="alt"/>
  </picture>

  <source v-else
          :media="media"
          :srcset="generateSrcset(hsId, format)"
          :type="`image/${format}`"/>
</template>

<style scoped>

</style>